import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthenticationState } from '../reducers/authentication.reducer';

export const selectAuthenticationState = createFeatureSelector<AuthenticationState>('authentication');

export const selectCredential = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.credential,
);

export const selectAuthenticationIsSuperUser = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => !!state.credential?.isSuperUser,
);

export const selectAuthenticationIsReseller = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => !!state.credential?.isReseller,
);

export const selectAuthenticationResellerId = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.credential?.resellerId,
);

export const selectAuthenticationPermissions = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.credential?.permissions,
);

export const selectAuthenticationResellerRoleId = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.credential?.resellerRoleId,
);

export const selectAuthentication = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.authentication,
);

export const selectAuthenticationForm = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.authenticationForm,
);

export const selectForgotPassword = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.forgotPassword,
);

export const selectForgotPasswordForm = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.forgotPasswordForm,
);

export const selectChangePassword = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.changePassword,
);

export const selectChangePasswordForm = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.changePasswordForm,
);

export const selectAuthenticationError = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.error,
);

export const selectAuthenticationLoading = createSelector(
  selectAuthenticationState,
  (state: AuthenticationState) => state.loading,
);